module.exports = __webpack_public_path__ + "static/media/kitchen-2.af9f1bc2.jpg";